import type { Permission } from "@mongmee/domain";

export function tenantPagePermission(page: string): Permission {
  const permissions: Record<string, Permission> = {
    dashboard: "tenant.read",
    onboarding: "tenant.manage",
    "automation-settings": "tenant.manage",
    brands: "brand.read",
    team: "team.read",
    audit: "audit.read",
    content: "content.read",
    approvals: "content.approve",
    calendar: "content.read",
    "content-history": "content.read",
    "content-operations": "content.manage",
    "ai-settings": "ai.manage",
    research: "research.read",
    knowledge: "research.read",
    channels: "channel.read",
    "data-rights": "tenant.manage",
  };
  return permissions[page] ?? "tenant.read";
}
